$(document).ready(function() {
  $(document).on('click', '.gv-mmy-bar .gv-btn-search', function() {
    // Check if the button is not disabled
    if (!$(this).prop("disabled")) {
      // Change the value to "Loading..." when clicked
      $(this).val("Loading...").css("background-color", "#589142");;
    }
  });
});

// Mobile: the vehicle selector is collapsed by CSS (govedia-ov.css) until the
// SELECT VEHICLE prompt is tapped. Delegated, because the Govedia app injects
// the bar after page load.
$(document).ready(function() {
  $(document).on('click keydown', '.gv-mmy-bar .gv-prompt-mobile', function(e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
      return;
    }
    e.preventDefault();
    $(this).closest('.gv-mmy-bar').toggleClass('gv-expanded');
  });

  var gvPromptA11y = setInterval(function() {
    var $prompt = $('.gv-mmy-bar .gv-prompt-mobile');
    if ($prompt.length) {
      $prompt.attr({ role: 'button', tabindex: 0, 'aria-label': 'Select vehicle' });
      clearInterval(gvPromptA11y);
    }
  }, 500);
  setTimeout(function() { clearInterval(gvPromptA11y); }, 15000);
});
